  <script>
  import Layout from "../../layouts/main";
  import Banner from "@/components/banner.vue"
  import GiftCardApi from "@/services/gift-card-api";
  import SettingsApi from "@/services/settings-api";

  
  export default ({
    name: "gift-card",
  
    components: {
      Layout, Banner
    },

    props: {
      orderId:{
            type: String,
            default:null
          },
    },
  
    
    data() {
      return {

        giftCard:{name:'' , mail:'' ,confirmationMailReceiver:'' , mailReceiver:'' , nameReceiver:'' , amount:0 ,message:''},
        giftAmount: null,
        errorMsg: null,
      }
    },

    mounted(){
      if(this.orderId != 'undefined' && this.orderId){
        this.getGiftCard()
      }
      this.getGiftCardAmount()
    },
    watch:{
    },
    methods:{
      getGiftCard(){
        GiftCardApi.getGiftCard(this.orderId).then((result)=>{
          if(result){
            this.giftCard = result
          }
        })
      },
      
      getGiftCardAmount(){
        SettingsApi.getGiftCardAmount().then(
          result =>{
            if(result){
              this.giftAmount = result
              this.giftCard.amount = this.giftAmount[0].amount
            }
          }
        )
      },

      selectData(data) {
        this.giftCard.amount = data.amount;
    },

      paymentProsses(){ 

        this.errorMsg = null;

         GiftCardApi.paymentProsses(this.giftCard).then(
          (result)=>{
            if(result.paymentUrl){
              window.location.href = result.paymentUrl;

            }
          }
         )
         .catch(error => {this.errorMsg = error;})
      },
    
    }

        
  });
  </script>
  
  <template>
    <Layout>
      <Banner style="max-height:200px;" pageTitle='E-Carte Cadeaux' subtitle1="Envoyer des cartes cadeaux à vos amis et proches !" subtitle2="La carte numérique de HA" :imageBackGround="false" :small="true"  ></Banner>

      <div class="row mt-2">
        <div class="col-12" style="display: contents;">
            <div class="col-xl-1 col-lg-0"/>
            <div class="col-xl-5 col-lg-6 col-sm-12 pr-md-4 mt-0 mt-lg-4 p-0 p-sm-1 p-lg-4" style="overflow: hidden; max-height:  800px;">
              
              <img v-if="giftCard.amount " :src="require('@/assets/images/' + giftCard.amount +'.jpg')"  style=" max-width: 100%; ">
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-12 p-0 p-sm-1 p-lg-4">
                <div class="row mt-3">
                    <div class="col-12" style="display: contents">
                    <div class="col-lg-6 col-sm-12 pr-md-4 ">
                        <b-form-group>
                          <label for="ref" class="font-size-16 text-dark font-weight-bold ">Expéditeur*</label>
                          <input
                          placeholder="Votre Nom et Prénom"
                          id="ref"
                          type="text"
                          class="form-control font-size-16"
                          v-model="giftCard.name"
                          />
                        </b-form-group>

                    </div>
                    <div class="col-lg-6 col-sm-12  " style="height: 52px;">
                        <b-form-group>
                          <label for="ref" class="font-size-16 text-dark font-weight-bold ">E-mail de l'expéditeur*</label>
                          <input
                          placeholder="Votre E-Mail"
                          id="ref"
                          type="text"
                          class="form-control font-size-16"
                          v-model="giftCard.mail"
                          />
                        </b-form-group>

                    </div>

                    </div>
                </div>

                <div class="font-size-16 text-dark font-weight-bold mt-5 mt-lg-3  ">
                    Choisir un montant
                    
                    <div v-if="giftAmount" class="row mt-2">
                      <div v-for="data in giftAmount" :key="data.amount" class="col-xl-3 col-md-4 col-sm-6 col-6 mb-1 pr-2 p-2 ">
                            <div 
                                class="card text-center font-size-22 text-dark pt-5 pb-5 mr-1" 
                                :class="{ 'selected': data.amount === giftCard.amount }"
                                style="border-radius: 6px; border: 1px solid rgba(203, 203, 203, 1); cursor: pointer;" 
                                @click="selectData(data)" >
                            {{ data.amountAsString }}
                          </div>
                      </div>
                    </div>

                </div>

                <div class="pr-md-6 mt-4">

                <b-form-group>
                    <label for="ref" class="font-size-16 text-dark font-weight-bold  mt-2">Nom et prénom du destinataire*</label>
                    <input
                    placeholder="Nom et prénom du destinataire"
                    id="ref"
                    type="text"
                    class="form-control font-size-16"
                    v-model="giftCard.nameReceiver"
                    />
                </b-form-group>

                <b-form-group>
                    <label for="ref" class="font-size-16 text-dark font-weight-bold  mt-2">E-Mail du destinataire*</label>
                    <input
                    placeholder="E-Mail du destinataire"
                    id="ref"
                    type="text"
                    class="form-control font-size-16"
                    v-model="giftCard.mailReceiver"
                    />
                </b-form-group>

                <b-form-group>
                    <label for="ref" class="font-size-16 text-dark font-weight-bold mt-2">Confirmation de l’adresse e-mail du destinatire*</label>
                    <input
                    placeholder="Confirmation de l'adresse e-mail du destinataire"
                    id="ref"
                    type="text"
                    class="form-control font-size-16"
                    v-model="giftCard.confirmationMailReceiver"
                    />
                </b-form-group>
                <b-form-group label="" label-for="">
                  <label for="ref" class="font-size-16 text-dark font-weight-bold mt-2">Message</label>
                        <textarea v-model="giftCard.message" class="form-control font-size-14" :maxlength="300" rows="5" placeholder="Ajouter un message à envoyer au destinataire"></textarea>
                    </b-form-group>

                <div class="row mt-4">
                  <div class="col-12 text-right">
                    <span v-show="errorMsg" class="text-warning font-weight-bold">{{this.errorMsg}}</span>
                  </div>
                </div>
                

                <b-button  variant="dark" class="getStarted1 font-size-18 font-weight-bold text-dark btn-block mt-2 " @click="paymentProsses()">Envoyer</b-button>

                <div class="row mt-5">
                    <div class="col-12" >
                        <h5 class="text-secondary font-size-20">Conditions d'Utilisations</h5>
                          <p class="font-size-16 text-secondary text-justify mt-3">
                            Carte cadeau utilisable uniquement sur <a class="text-warning" href="https://ha.com.tn">www.ha.com.tn</a>, 
                            utilisable en une seule fois dans la limite du solde disponible. Aucun rendu d'espèce ne sera effectué. Carte non utilisable pour l’achat d’autres cartes cadeaux.
                          </p>
                    </div>
                  </div>

            </div>
            </div>
            <div class="col-xl-1  col-lg-0" />

        </div>

      </div>

     
  
    </Layout>
  </template>
  <style scoped>
  
  .selected {
    /*border: 2px solid #4e4e4e !important; */
    /*box-shadow: 0px 0px 10px 0px #4b4b4b; */
    background-color: #000;
    border: none !important;
    color: #fff !important;
}
  </style>
  